import React from 'react';
import Text from '@service-victoria/component-library/components/Text';
import Input from '@service-victoria/component-library/components/Input';
import Dropdown from '@service-victoria/component-library/components/Dropdown';
import RadioButton, {
  ItemType as RadiobuttonItem
} from '@service-victoria/component-library/components/RadioButton';
import Checkbox from '@service-victoria/component-library/components/Checkbox';
import { StepComponent } from '@service-victoria/component-library/components/Wizard/props';
import * as Interfaces from 'interfaces';
import * as Styled from '../styled';
import ProofTypePicker from './ProofTypePicker';
import { constants } from 'utils';

export const validProofTypes: RadiobuttonItem[] = [
  {
    label: 'Victorian driver licence',
    value: 'licence'
  },
  {
    label: 'Victorian seniors card',
    value: 'seniorsCard'
  },
  {
    label: 'Victorian proof-of-age card',
    value: 'proofOfAgeCard'
  }
];

export type ComponentProps = StepComponent<Pick<Interfaces.Common.FormValues, 'identity'>>;

const Identity: React.FC<ComponentProps> = ({ context }) => {
  const {
    form: { values }
  } = context;

  return (
    <Styled.Wrapper>
      <Text.Heading.H1 fontWeight={600}>Your details</Text.Heading.H1>
      <Styled.Spacer48 />
      <Input name='identity.email' label='Email' ariaLabel='Your e-mail address' />
      <Styled.Spacer24 />
      <Input
        name='identity.confirmEmail'
        label='Confirm email'
        ariaLabel='Confirm e-mail address'
      />
      <Styled.Spacer24 />
      <Input label='Mobile phone' name='identity.phone' />
      <Text.Body>
        (Your mobile number will ensure we can contact you regarding your $200 payment)
      </Text.Body>
      <Styled.Spacer48 />
      <Text.Heading.H2 style={{ fontWeight: 600 }}>Your eligibility</Text.Heading.H2>
      <Styled.Spacer24 />
      <Text.Body style={{ fontWeight: 600 }}>I am a Victorian resident</Text.Body>
      <Text.Body>My proof (pick one):</Text.Body>
      <RadioButton name='identity.proofType' groupLabel='' items={validProofTypes} />
      <Styled.Spacer24 />
      <ProofTypePicker identity={values.identity} />
      <Styled.Spacer48 />
      <Text.Heading.H3 style={{ fontWeight: 600 }}>Home address (no PO Boxes)</Text.Heading.H3>
      <Styled.Spacer16 />
      <Styled.InputContainer>
        <Input
          label='Street address'
          name='identity.address.fullDetails.fullAddress'
          hint='Include unit or apartment number'
        />
      </Styled.InputContainer>
      <Styled.InputContainer>
        <Input label='Suburb/Town' name='identity.address.fullDetails.suburb' />
      </Styled.InputContainer>
      <Styled.InputContainer>
        <Dropdown
          name='identity.address.fullDetails.state'
          label='State/Territory'
          options={constants.stateOptions}
          placeholder='Select'
        />
      </Styled.InputContainer>
      <Styled.InputContainer>
        <Input label='Postcode' name='identity.address.fullDetails.postCode' />
      </Styled.InputContainer>
      <Styled.Spacer24 />
      <Checkbox
        name='identity.noPriorTravel'
        label='I confirm that neither I nor anybody else in my household has already claimed a Melbourne travel voucher under this scheme'
      />
    </Styled.Wrapper>
  );
};

export default Identity;
